import React, { lazy, Suspense } from 'react';

const LazyPlayerComponent = lazy(() => import('./PlayerComponent'));

const PlayerComponent = props => (
  <Suspense fallback={null}>
    <LazyPlayerComponent {...props} />
  </Suspense>
);

export default PlayerComponent;
